<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 d-none d-md-inline-block">
          <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <div class="card form_laive" :class="{ validateClient: loading }">
            <div class="box_loader">
              <div class="loader"></div>
            </div>
            <div class="card-header">
              <h3 class="mb-0">Editar pedído mínimo: {{ filter.nombreCombinacion }}</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 col-lg-2">
                  <ul class="progressbar_vertical">
                    <li class="step_grupo" :class="{ active: steps.one }" data-text="Actualizar combinación">1</li>
                    <li class="step_grupo" :class="{ active: steps.two }" data-text="Clientes afectados">2</li>
                  </ul>
                </div>
                <div class="col-md-9 col-lg-10">
                  <form @submit.prevent="calculateCombination" v-if="steps.two == false">
                    <div class="row">
                      <div class="col-md-4 d-none">
                        <label class="form-control-label">Nombre de la combinación</label>
                        <base-input
                          required
                          name="name_combinacion"
                          placeholder="Nombre de la combinación"
                          v-model="filter.nombreCombinacion"
                        >
                        </base-input>
                      </div>
                      <div class="col-md-4 d-none">
                        <label class="form-control-label">Distribuidoras</label>
                        <div class="form-group">
                          <select
                            v-model="filter.idDistribuidora"
                            required
                            class="form-control"
                            name="distributor_select"
                          >
                            <option value="0">Seleccione una distribuidora</option>
                            <option
                              v-for="item in distribuidoras"
                              :value="String(item.idDistribuidora)"
                              :key="item.idDistribuidora"
                            >
                              {{ item.razonSocial }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label class="form-control-label">Monto mínimo</label>
                        <base-input
                          required
                          name="name_montominimo"
                          placeholder="Ingrese el monto"
                          v-model.number="filter.montoMinimo"
                          @keypress="isNumber($event)"
                        >
                          <template v-slot:addonLeft>S/</template>
                        </base-input>
                      </div>
                      <!-- Data combinacion -->
                      <div class="col-md-12">
                        <template v-if="dataCombinacion['antiguedad']">
                          <div class="row">
                            <div class="col-md-12">
                              <label class="form-control-label">Antiguedad</label>
                            </div>
                            <div
                              class="col-md-2 col-lg-3"
                              v-for="item in dataCombinacion['antiguedad']"
                              :key="item.nombre"
                            >
                              <div class="radio">
                                <input
                                  type="radio"
                                  required
                                  v-model="filter.antiguedad"
                                  name="antiguedad"
                                  :id="`antiguedad-${item.codigo}`"
                                  class="radio__input"
                                  :value="item.codigo"
                                />
                                <label :for="`antiguedad-${item.codigo}`" class="radio__label">{{ item.nombre }}</label>
                              </div>
                            </div>
                            <!-- <div class="col-md-2 col-lg-3 pl-0">
                              <base-button type="info" class="detail" size="sm" @click="openModal">Actualizar antiguedad</base-button>
                            </div> -->
                          </div>
                        </template>
                        <template v-if="dataCombinacion['giros']">
                          <div class="row">
                            <div class="col-md-12">
                              <label class="form-control-label">Giros</label>
                            </div>
                            <div class="col-md-2 col-lg-3">
                              <div class="radio custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  v-model="allGirosSelected"
                                  name="girosAll"
                                  id="girosAll"
                                  class="custom-control-input"
                                />
                                <label for="girosAll" class="custom-control-label">Todos</label>
                              </div>
                            </div>
                            <div class="col-md-2 col-lg-3" v-for="item in dataCombinacion['giros']" :key="item.nombre">
                              <div class="radio custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  v-model="formatGiroNegocio"
                                  name="giros"
                                  :id="`giros-${item.codigo}`"
                                  class="custom-control-input"
                                  :value="item.codigo"
                                />
                                <label :for="`giros-${item.codigo}`" class="custom-control-label">{{
                                  item.nombre
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-if="dataCombinacion['segmentos']">
                          <div class="row">
                            <div class="col-md-12">
                              <label class="form-control-label">Segmentos</label>
                            </div>
                            <div class="col-md-2 col-lg-3">
                              <div class="radio custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  v-model="allSegmentosSelected"
                                  name="segmentosAll"
                                  id="segmentosAll"
                                  class="custom-control-input"
                                />
                                <label for="segmentosAll" class="custom-control-label">Todos</label>
                              </div>
                            </div>
                            <div
                              class="col-md-2 col-lg-3"
                              v-for="item in dataCombinacion['segmentos']"
                              :key="item.nombre"
                            >
                              <div class="radio custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  v-model="formatSegmentos"
                                  name="segmentos"
                                  :id="`segmentos-${item.codigo}`"
                                  class="custom-control-input"
                                  :value="item.codigo"
                                />
                                <label :for="`segmentos-${item.codigo}`" class="custom-control-label">{{
                                  item.nombre
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-if="dataCombinacion['tipoCombinacion']">
                          <div class="row">
                            <div class="col-md-12">
                              <label class="form-control-label">Tipo de Combinacion</label>
                            </div>
                            <div
                              class="col-md-2 col-lg-3"
                              v-for="item in dataCombinacion['tipoCombinacion']"
                              :key="item.nombre"
                            >
                              <div class="radio">
                                <input
                                  type="radio"
                                  required
                                  v-model="filter.tipo"
                                  name="tipoCombinacion"
                                  :id="`tipoCombinacion-${item.codigo}`"
                                  class="radio__input"
                                  :value="Number(item.codigo)"
                                />
                                <label :for="`tipoCombinacion-${item.codigo}`" class="radio__label">{{
                                  item.nombre
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-if="dataCombinacion['equiposFrio']">
                          <div class="row">
                            <div class="col-md-12">
                              <label class="form-control-label">Equipos de Frio</label>
                            </div>
                            <div class="col-md-2 col-lg-3">
                              <div class="radio custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  v-model="allEquiposSelected"
                                  name="equiposAll"
                                  id="equiposAll"
                                  class="custom-control-input"
                                />
                                <label for="equiposAll" class="custom-control-label">Todos</label>
                              </div>
                            </div>
                            <div
                              class="col-md-2 col-lg-3"
                              v-for="item in dataCombinacion['equiposFrio']"
                              :key="item.nombre"
                            >
                              <div class="radio custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  v-model="formatEquipoFrio"
                                  name="equiposFrio"
                                  :id="`equiposFrio-${item.codigo}`"
                                  class="custom-control-input"
                                  :value="item.codigo"
                                />
                                <label :for="`equiposFrio-${item.codigo}`" class="custom-control-label">{{
                                  item.nombre
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="col">
                        <base-button type="primary" native-type="submit" class="btn-default my-0 mt-2"
                          >Actualizar pedido mínimo</base-button
                        >
                      </div>
                    </div>
                  </form>
                  <template v-if="steps.two == true">
                    <div class="row">
                      <div class="col-md-12" v-if="usersAffected.created == false">
                        <template v-if="resumenSinConflictos">
                          <p class="col-form-label form-control-label">
                            Se han encontrado 0 clientes que pertenecen a otra combinación. Puede ir a la bandeja de
                            pedido mínimo.
                          </p>
                          <router-link
                            :to="{ name: 'Pedido minimo' }"
                            class="btn base-button btn-primary btn-default my-0 mt-2"
                            >Ir a bandeja de pedido mínimo</router-link
                          >
                        </template>
                        <form v-else @submit.prevent="updateCreate">
                          <p class="col-form-label form-control-label">
                            {{ usersAffected.message }}
                          </p>
                          <base-button type="primary" native-type="submit" class="btn-default my-0 mt-2"
                            >Continuar con la actualización</base-button
                          >
                        </form>
                      </div>
                      <template v-if="usersAffected.created">
                        <div class="col-md-12">
                          <template v-if="usersInsideFilter.data.length">
                            <p class="form-control-label">Clientes que ya se encuentran en otra combinación</p>
                            <el-table
                              :data="resumenClientesPaged"
                              :max-height="resumenTableMaxHeight"
                              row-key="idUsersInsideFilter"
                              empty-text="No se encontraron resultados"
                              header-row-class-name="thead-light"
                            >
                              <el-table-column
                                v-for="column in usersInsideFilter.tableColumns"
                                :key="column.label"
                                v-bind="column"
                              >
                              </el-table-column>
                            </el-table>
                            <div class="mt-3 d-flex justify-content-end align-items-center flex-wrap">
                              <select
                                class="form-control form-control-sm d-inline-block mb-0 mr-3"
                                style="width: auto; min-width: 4.25rem"
                                aria-label="Filas por página"
                                :value="resumenPagination.pageSize"
                                @change="onResumenPageSizeChange($event.target.value)"
                              >
                                <option v-for="n in resumenPageSizeOptions" :key="n" :value="n">{{ n }}</option>
                              </select>
                              <el-pagination
                                :current-page="resumenPagination.currentPage"
                                :page-size="resumenPagination.pageSize"
                                :total="usersInsideFilter.data.length"
                                layout="prev, pager, next"
                                @current-change="onResumenPageChange"
                              />
                            </div>
                          </template>
                          <template v-else>
                            <p class="form-control-label">No hay clientes duplicados en otra combinación</p>
                          </template>
                        </div>
                        <div class="col-md-12">
                          <router-link
                            :to="{ name: 'Pedido minimo' }"
                            class="btn base-button btn-primary btn-default my-0 mt-2"
                            >Ir al listado
                          </router-link>
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CustomModal
    :show="modal.open"
    :isHeader="true"
    :isFooter="false"
    :width="600"
    title="Actualizar los meses de antiguedad de clientes"
    v-on:modal:close="modal.open = $event"
  >
    <template v-slot:body>
      <form @submit.prevent="updatedAntiguedad" class="form_laive" :class="{ validateClient: modal.loading }">
        <div class="box_loader">
          <div class="loader"></div>
        </div>
        <label class="col-form-label form-control-label">Meses de antiguedad de clientes</label>
        <base-input
          required
          name="meses_antiguedad"
          placeholder="Antiguedad de cliente"
          v-model="mesesAntiguedad.valor"
          @keypress="isNumber($event)"
        >
        </base-input>
        <base-button type="primary" native-type="submit" class="btn-default my-0 mt-2">Actualizar meses</base-button>
      </form>
    </template>
  </CustomModal>
</template>
<script>
import axios from "axios";
import { ElTable, ElTableColumn, ElSelect, ElOption, ElInput, ElPagination } from "element-plus";
import { mapGetters } from "vuex";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import DashboardNavbar from "../Layout/DashboardNavbar";
import { useToast } from "vue-toastification";
import Notification from "@/components/Notification";
import CustomModal from "../Components/CustomModal.vue";
export default {
  components: {
    DashboardNavbar,
    RouteBreadCrumb,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
    [ElPagination.name]: ElPagination,
    CustomModal,
  },
  created() {
    const $this = this;
    const idPedido = this.$route.params.id;
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    let urlDistribuidoras = process.env.VUE_APP_API_URL + "/distribuidoras/lista";
    const getDistribuidoras = axios.get(urlDistribuidoras, config);
    let urlDataCombinacion = process.env.VUE_APP_API_URL + "/pedidominimo/data-para-combinacion";
    const getDataCombinacion = axios.get(urlDataCombinacion, config);
    const urlMesesAntiguedad = process.env.VUE_APP_API_URL + "/parametro/lista/meses_antiguedad_cliente";
    const getMesesAntiguedad = axios.get(urlMesesAntiguedad, config);
    const urlDetailPedido = process.env.VUE_APP_API_URL + "/pedidominimo/detalle/" + idPedido;
    const getDetailPedido = axios.get(urlDetailPedido, config);
    axios
      .all([getDistribuidoras, getDataCombinacion, getMesesAntiguedad, getDetailPedido])
      .then(
        axios.spread((...responses) => {
          const resDistribuidoras = responses[0].data;
          $this.distribuidoras = resDistribuidoras
            ? resDistribuidoras.filter((item) => {
                return item.estado == "1";
              })
            : [];
          const resDataCombinacion = responses[1].data;
          $this.dataCombinacion = resDataCombinacion;
          const resMesesAntiguedad = responses[2].data[0];
          $this.mesesAntiguedad = resMesesAntiguedad;
          const resDetailPedido = responses[3].data;
          $this.filter = resDetailPedido;
          // Preserve empty values from API CSV (e.g. ",01,02") because empty code maps to "Vacío".
          const parseCsvKeepingEmpty = (value) => {
            if (typeof value !== "string") return [];
            const parts = value.split(",");
            return [...new Set(parts)];
          };
          $this.filter.tempGiroNegocio = parseCsvKeepingEmpty(resDetailPedido.giroNegocio);
          $this.filter.tempSegmento = parseCsvKeepingEmpty(resDetailPedido.segmento);
          $this.filter.tempEquipoFrio = parseCsvKeepingEmpty(resDetailPedido.equipoFrio);
          $this.filter.idPedidoMinimo = idPedido;
          $this.loading = false;
        })
      )
      .catch((errors) => {
        console.log("Error en carga inicial EditarPedidoMinimo:", errors);
        $this.loading = false;
      });
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
    formatGiroNegocio: {
      get() {
        return this.filter.tempGiroNegocio;
      },
      set(val) {
        this.filter.tempGiroNegocio = val;
        this.filter.giroNegocio = this.filter.tempGiroNegocio.join(",");
      },
    },
    formatSegmentos: {
      get() {
        return this.filter.tempSegmento;
      },
      set(val) {
        this.filter.tempSegmento = val;
        this.filter.segmento = this.filter.tempSegmento.join(",");
      },
    },
    formatEquipoFrio: {
      get() {
        return this.filter.tempEquipoFrio;
      },
      set(val) {
        this.filter.tempEquipoFrio = val;
        this.filter.equipoFrio = this.filter.tempEquipoFrio.join(",");
      },
    },
    allGirosSelected: {
      get() {
        const options = this.dataCombinacion["giros"] || [];
        return options.length > 0 && this.filter.tempGiroNegocio.length === options.length;
      },
      set(checked) {
        const selected = checked ? (this.dataCombinacion["giros"] || []).map((u) => u.codigo) : [];
        this.filter.tempGiroNegocio = selected;
        this.filter.giroNegocio = selected.join(",");
      },
    },
    allSegmentosSelected: {
      get() {
        const options = this.dataCombinacion["segmentos"] || [];
        return options.length > 0 && this.filter.tempSegmento.length === options.length;
      },
      set(checked) {
        const selected = checked ? (this.dataCombinacion["segmentos"] || []).map((u) => u.codigo) : [];
        this.filter.tempSegmento = selected;
        this.filter.segmento = selected.join(",");
      },
    },
    allEquiposSelected: {
      get() {
        const options = this.dataCombinacion["equiposFrio"] || [];
        return options.length > 0 && this.filter.tempEquipoFrio.length === options.length;
      },
      set(checked) {
        const selected = checked ? (this.dataCombinacion["equiposFrio"] || []).map((u) => u.codigo) : [];
        this.filter.tempEquipoFrio = selected;
        this.filter.equipoFrio = selected.join(",");
      },
    },
    resumenClientesPaged() {
      const rows = this.usersInsideFilter.data || [];
      const start = (this.resumenPagination.currentPage - 1) * this.resumenPagination.pageSize;
      return rows.slice(start, start + this.resumenPagination.pageSize);
    },
    resumenSinConflictos() {
      const n = Number(this.usersAffected.clientes);
      return !Number.isNaN(n) && n === 0;
    },
  },
  mounted() {
    if (this.user.rol == 3) {
      this.distribuidoraIdCurrent = this.user.idDistribuidora;
      this.filter.idDistribuidora = String(this.user.idDistribuidora);
    }
  },
  methods: {
    onResumenPageChange(page) {
      this.resumenPagination.currentPage = page;
    },
    onResumenPageSizeChange(value) {
      const size = Number(value);
      if (Number.isNaN(size) || size < 1) return;
      this.resumenPagination.pageSize = size;
      this.resumenPagination.currentPage = 1;
    },
    resetResumenPagination() {
      this.resumenPagination.currentPage = 1;
    },
    showToast(text, type = "success") {
      const content = {
        component: Notification,
        props: {
          icon: "ni ni-bell-55",
          text,
          type,
        },
      };
      const toast = useToast();
      toast(content, {
        hideProgressBar: true,
        icon: false,
        closeButton: false,
        position: "top-right",
      });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    calculateCombination(evn) {
      console.log("calculateCombination: ", evn);
      const $this = this;
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      this.loading = true;
      const dataSend = this.filter;
      const urlApiCalculate = process.env.VUE_APP_API_URL + "/pedidominimo/calcular";
      axios
        .post(urlApiCalculate, dataSend, config)
        .then(function (response) {
          $this.loading = false;
          $this.steps.two = true;
          const firstResult = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : null;
          if (firstResult) {
            $this.usersAffected.clientes = firstResult.nroClientes;
            $this.usersAffected.distribuidora = firstResult.distribuidora;
            $this.usersAffected.message = `Se han encontrado ${firstResult.nroClientes} clientes que pertenecen a otra combinación.`;
          } else {
            $this.usersAffected.clientes = 0;
            $this.usersAffected.distribuidora = "";
            $this.usersAffected.message = "No se han encontrado clientes afectados";
          }
        })
        .catch(function (error) {
          console.log("Error al calcular combinación en EditarPedidoMinimo:", error);
          $this.showToast("No se pudo calcular la combinación", "danger");
          $this.loading = false;
        });
    },
    updateCreate(evn) {
      console.log("updateCreate: ", evn);
      const $this = this;
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      this.loading = true;
      const dataSend = this.filter;
      const urlApiCreate = process.env.VUE_APP_API_URL + "/pedidominimo/actualizar";
      axios
        .post(urlApiCreate, dataSend, config)
        .then(function (response) {
          const text = response.status == 200 ? "Se actualizó el pedido mínimo" : "Hubo un error";
          $this.showToast(text, response.status == 200 ? "success" : "danger");
          $this.loading = false;
          $this.usersAffected.created = true;
          $this.usersInsideFilter.data = response.data.resumen.length ? response.data.resumen : [];
          $this.resetResumenPagination();
        })
        .catch(function (error) {
          console.log("Error al actualizar pedido mínimo:", error);
          $this.showToast("No se pudo actualizar el pedido mínimo", "danger");
          $this.loading = false;
        });
    },
    openModal() {
      this.modal.open = true;
    },
    updatedAntiguedad() {
      const $this = this;
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      this.modal.loading = true;
      const dataSend = this.mesesAntiguedad;
      const urlApiUpdated = process.env.VUE_APP_API_URL + "/parametro/actualizar";
      axios
        .put(urlApiUpdated, dataSend, config)
        .then(function (response) {
          const text = response.status == 200 ? "Se actualizó la antigüedad de clientes" : "Hubo un error";
          $this.showToast(text, response.status == 200 ? "success" : "danger");
          $this.modal.loading = false;
          setTimeout(() => {
            $this.modal.open = false;
          }, 350);
        })
        .catch(function (error) {
          console.log("Error al actualizar antigüedad (EditarPedidoMinimo):", error);
          $this.showToast("No se pudo actualizar la antigüedad de clientes", "danger");
          $this.modal.loading = false;
          $this.modal.open = false;
        });
    },
  },
  data() {
    return {
      loading: true,
      distribuidoraIdCurrent: null,
      distribuidoras: [],
      dataCombinacion: [],
      steps: {
        one: true,
        two: false,
      },
      modal: {
        title: "",
        open: false,
        loading: false,
      },
      usersAffected: {
        created: false,
        clientes: "",
        distribuidora: "",
        message: "",
      },
      resumenTableMaxHeight: 420,
      resumenPageSizeOptions: [10, 25, 50, 100],
      resumenPagination: {
        currentPage: 1,
        pageSize: 25,
      },
      mesesAntiguedad: {},
      filter: {
        nombreCombinacion: "",
        idDistribuidora: "0",
        antiguedad: "",
        giroNegocio: "",
        tempGiroNegocio: [],
        segmento: "",
        tempSegmento: [],
        tipo: "",
        equipoFrio: "",
        tempEquipoFrio: [],
        montoMinimo: "",
      },
      usersInsideFilter: {
        tableColumns: [
          {
            prop: "distribuidora",
            label: "Distribuidora",
            minWidth: 120,
          },
          {
            prop: "codigoCliente",
            label: "Cog. Cliente",
            minWidth: 120,
          },
          {
            prop: "nombreCliente",
            label: "Cliente",
            minWidth: 120,
          },
        ],
        data: [],
      },
    };
  },
};
</script>
